define("settings/templates/overview/leave", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Modal::LeaveLater @canClose={{this.canClose}} @goToFree={{this.goToFree}} />
  */
  {
    "id": "xSdImQIf",
    "block": "[[[8,[39,0],null,[[\"@canClose\",\"@goToFree\"],[[30,0,[\"canClose\"]],[30,0,[\"goToFree\"]]]],null]],[],false,[\"modal/leave-later\"]]",
    "moduleName": "settings/templates/overview/leave.hbs",
    "isStrictMode": false
  });
});